import { buildActionCreators, makeActionTypes } from '../../common/helpers/ReduxHelpers';

import { DOMAIN } from './Dashboard.constants';
import { singleParameter } from '../../common/helpers/Redux/parameterize';

export const events = {
    updateSelectedDomain: singleParameter,
    updateTodoPreferences: singleParameter,
};

export const types = makeActionTypes(Object.keys(events), DOMAIN);

export default buildActionCreators(events, types);
